import { render, staticRenderFns } from "./RecShareAssetMgmt.vue?vue&type=template&id=342dd3a4"
import script from "./RecShareAssetMgmt.vue?vue&type=script&lang=js"
export * from "./RecShareAssetMgmt.vue?vue&type=script&lang=js"
import style0 from "./RecShareAssetMgmt.vue?vue&type=style&index=0&id=342dd3a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports